import BaseService from "./BaseService";

export default {
    index() {
        return BaseService.get('/transaction-categories');
    },
    treeViewItems() {
        return BaseService.get('/transaction-tree-view-categories');
    },
    createTransactionCategory(data) {
        return BaseService.post('/transaction-categories', data);
    },
    updateTransactionCategory(id, data) {
        return BaseService.put('/transaction-categories/' + id, data);
    },
    deleteTransactionCategory(id) {
        return BaseService.delete('/transaction-categories/' + id);
    },
}